import React from 'react';

import { Grid, Card, CardContent, Theme, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { COLOR_PRIMARY_1 } from 'src/colors';
import { COLOR_TOOLTIP_BACKGROUND } from 'src/const';
import { Chip } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: 'transparent',
    padding: 0,
    height: '80px',
  },
}));

const FilterChip = ({
  label,
  value,
  variant,
  handleOnClick,
  styles,
  tooltipText,
}: {
  variant: 'filled' | 'outlined';
  label: string | number | JSX.Element;
  value: string | number | (number | 'all')[];
  handleOnClick: (value: string | number | (number | 'all')[]) => void;
  styles?: any;
  tooltipText?: string;
}) => {
  const classes = useStyles();

  const chipComponent = (
    <Chip
      label={label}
      variant={variant}
      onClick={() => handleOnClick(value)}
      sx={{
        minWidth: 50,
        marginTop: '10px',
        marginRight: '5px',
        borderColor: COLOR_PRIMARY_1,
        borderWidth: '1px',
        color: COLOR_PRIMARY_1,
        fontWeight: 500,
        '&.MuiChip-filled': {
          backgroundColor: COLOR_PRIMARY_1,
          color: '#fff',
        },
        ...styles,
      }}
    />
  );

  if (!tooltipText) {
    return chipComponent;
  }

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      title={
        <Card style={{ width: '160px', height: '60px' }}>
          <CardContent
            style={{ background: COLOR_TOOLTIP_BACKGROUND, height: '60px', fontSize: '18px' }}
          >
            <Grid container direction="column" alignItems="flex-start">
              <Typography variant="body1">{tooltipText ? tooltipText : ''}</Typography>
            </Grid>
          </CardContent>
        </Card>
      }
    >
      {chipComponent}
    </Tooltip>
  );
};

export default FilterChip;
